let dietExper = [
  {
    path: 'dietExpertApply',
    meta: {
      title: '食疗专家申请',
      breadcrumb: true
    },
    component: {
      name: 'dietExpertApply',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '食疗专家申请',
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietExpertApply'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietExpertApply/detail'], resolve)
      },
    ]
  },
  {
    path: 'dietExpertList',
    meta: {
      title: '食疗专家管理',
      breadcrumb: true
    },
    component: {
      name: 'dietExpertList',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '食疗专家',
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietExpertList'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增食疗专家",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietExpertList/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑食疗专家",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietExpertList/editor'], resolve)
      }
    ]
  },
  {
    path: 'dietAdvisoryList',
    name: 'dietAdvisoryList',
    meta: {
      title: '食疗咨询',
      breadcrumb: true
    },
    component: (resolve) => require(['@/views/plat/dietExpert/dietAdvisoryList'], resolve)
  },
  {
    path: 'dietDept',
    meta: {
      title: '食疗科室',
      breadcrumb: true
    },
    component: {
      name: 'dietDept',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/plat/dietExpert/dietDept'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietDept/children/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietDept/children/editor'], resolve)
      },
      {
        path: 'setExpert',
        meta: {
          title: "绑定专家",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/dietDept/children/setExpert'], resolve)
      }
    ]
  },
  {
    path: 'planMgt',
    meta: {
      title: '方案管理',
      breadcrumb: true
    },
    component: {
      name: 'planMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/plat/dietExpert/planMgt'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/planMgt/children/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/dietExpert/planMgt/children/editor'], resolve)
      }
    ]
  },
]


export default {
  path: '/dietExpert',
  redirect: '/dietExpert/dietExpertList',
  meta: {
    title: "食疗专家",
    breadcrumb: true
  },
  component: {
    name: 'dietExpert',
    template: '<router-view></router-view>'
  },
  children: dietExper
}



// WEBPACK FOOTER //
// ./src/router/dietExpert.js